import type { IAccountRewards } from "@apis/rewards/types"
import { DollarSignIcon, PlusIcon } from "lucide-react"
import { AccountPromos } from "@components/AccountNew/Rewards/AccountPromos"
import { RewardChecks } from "@components/AccountNew/Rewards/Checks/RewardChecks"

export const serializeRewardsSection = (
  rewardsData: IAccountRewards,
  account_id: string,
) => {
  const rewards = rewardsData.all_account_rewards || []
  const description_lines = rewards
    .filter((reward) => reward.reward_status_code === "PENDING_REDEMPTION")
    .flatMap((reward) => [
      { content: <strong>{reward.description}</strong> },
      { content: reward.status_summary },
    ])
  const actions = [
    {
      icon: <PlusIcon size={16} />,
      displayedContent: <AccountPromos account_id={account_id} />,
      displayedTitle: "Account Promos",
      permission: "canAddPromo",
    },
    {
      icon: <DollarSignIcon size={16} />,
      displayedContent: <RewardChecks account_id={account_id} />,
      displayedTitle: "Checks",
    },
  ]

  return {
    actions,
    description_lines,
  }
}
